export function countdownParts(deadlineMs, nowMs) {
  if (!Number.isFinite(deadlineMs) || !Number.isFinite(nowMs)) return null;
  const remaining = Math.max(0, Math.floor((deadlineMs - nowMs) / 1000));
  return {
    expired: remaining === 0,
    days: Math.floor(remaining / 86400),
    hours: Math.floor((remaining % 86400) / 3600),
    minutes: Math.floor((remaining % 3600) / 60),
    seconds: remaining % 60,
  };
}

export function parseDeadline(value) {
  return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?(Z|[+-]\d{2}:\d{2})$/.test(value) ? Date.parse(value) : NaN;
}

export const pad = value => String(value).padStart(2, '0');

const SECONDS = { days: 86400, hours: 3600, minutes: 60, seconds: 1 };

// Splits the remaining seconds over the units a countdown shows; the first unit absorbs everything larger.
export function unitValues(remaining, units) {
  let rest = Math.max(0, Math.floor(Number(remaining) || 0));
  const values = {};
  for (const unit of units) {
    values[unit] = Math.floor(rest / SECONDS[unit]);
    rest -= values[unit] * SECONDS[unit];
  }
  return values;
}

if (typeof customElements !== 'undefined' && !customElements.get('ns-countdown')) {
  customElements.define('ns-countdown', class extends HTMLElement {
    static get observedAttributes() { return ['data-deadline']; }
    connectedCallback() { this.start(); }
    attributeChangedCallback() { if (this.isConnected) this.start(); }
    disconnectedCallback() { clearInterval(this.timer); }
    start() {
      clearInterval(this.timer);
      this.deadline = parseDeadline(this.dataset.deadline);
      if (!Number.isFinite(this.deadline)) { this.hidden = true; return; }
      this.hidden = false;
      this.removeAttribute('data-expired');
      this.querySelector('.ns-countdown__expired')?.setAttribute('hidden', '');
      this.tick();
      if (!this.hasAttribute('data-expired')) this.timer = setInterval(() => this.tick(), 1000);
    }
    tick() {
      const parts = countdownParts(this.deadline, Date.now());
      if (!parts) return;
      const cells = [...this.querySelectorAll('[data-unit]')];
      const values = unitValues(Math.max(0, Math.floor((this.deadline - Date.now()) / 1000)), cells.map(cell => cell.dataset.unit));
      for (const cell of cells) cell.textContent = pad(values[cell.dataset.unit]);
      if (parts.expired && !this.hasAttribute('data-expired')) {
        clearInterval(this.timer);
        this.setAttribute('data-expired', '');
        this.querySelector('.ns-countdown__expired')?.removeAttribute('hidden');
        this.dispatchEvent(new CustomEvent('ns:countdown-expired', { bubbles: true }));
      }
    }
  });
}
